var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":_vm.printWidth,"height":_vm.printHeight,"viewBox":_vm.viewBox,"xmlns":"http://www.w3.org/2000/svg"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }